module.exports = __webpack_public_path__ + "static/media/tablets.87d9f9bb.svg";